import { useEffect, useState } from "react";
import { Mask } from "antd-mobile"
import rich_bg from '@/assets/images/home_rich_bg_2.png'
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getActivityConfiguration } from '@/api'
import { getUserInfo } from '@/tools';
import './pddcontent.less';

// 拼多多弹窗
const PddContent = () => {
  const [visible, setVisible] = useState(false)
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const queryParams = searchParams.toString();
 const { getToken } = getUserInfo();

  const queryConfig = async () => {
    const { code, data } = await getActivityConfiguration();
    if (code === 200) {

      // 弹框时机: REGISTERED-注册后, VISITED-访问后, ALL-注册/访问后, CLOSED-关闭
      const { enabled, alertType } = data;
      if (enabled) {
      // if (enabled && !sessionStorage.getItem('pddcontent')) {
        // 活动开启
        switch (alertType) {
          case 'REGISTERED':
            if (getToken()) {
              setVisible(true);
              // sessionStorage.setItem('pddcontent', 'showOnce');
            }
            break;
          case 'VISITED':
          case 'ALL':
            setVisible(true);
            // sessionStorage.setItem('pddcontent', 'showOnce');
            break;

          default:
            break;
        }
      }
    }
  }

  const handleNavigateLink = (link) => {
      setVisible(false);
      navigate(queryParams ? `${link}?${queryParams}` : link);
  };

  useEffect(() => {
    queryConfig()
  }, [])

  return (
    <>
      <Mask visible={visible} className="pdd-share-content">
        <div className="relative mx-3 ">
          <img src={rich_bg} alt="" />
          <div
            onClick={() => setVisible(false)}
            className="w-10 h-10 absolute top-5 right-5"
          ></div>
          <div className="absolute w-[195px] bottom-20 left-0 right-0 mx-auto font-bold text-[#78340F] text-[16px]">
            Compartilhe o link para convidar amigos e ganhe imediatamente R$
            100
          </div>
          <div className="absolute bottom-5 left-0 right-0 mx-auto text-center ">
            <span
              onClick={() => handleNavigateLink('/promocao/cashwheel')}
              className="inline-block px-10 py-2 font-bold border-[3px] border-solid border-[#FCD7A1] recieve-btn-bg text-center  text-[#FCD7A1] rounded-3xl "
            >
              Receber
            </span>
          </div>
        </div>
      </Mask>
    </>
  );
}

export default PddContent;